import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/1168a418/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "what-is-the-carbon-design-system"
    }}>{`What is the Carbon Design System?`}</h3>
    <p>{`Carbon is the open-source design system for all IBM software products. It is a series of individual styles, components, and guidelines used for creating unified UI.`}</p>
    <h3 {...{
      "id": "who-works-on-carbon"
    }}>{`Who works on Carbon?`}</h3>
    <p>{`Carbon has a `}<a parentName="p" {...{
        "href": "https://github.com/orgs/carbon-design-system/people"
      }}>{`core team`}</a>{` of designers and front-end developers dedicated to developing and supporting the system. Our core team sits in the IBM Design Studio in Austin, Texas. There are also countless other designers and developers who contribute back to `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-components#contributors"
      }}>{`carbon-components`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-components-react#contributors"
      }}>{`carbon-react`}</a>{`.`}</p>
    <h3 {...{
      "id": "how-can-i-contribute-andor-propose-new-componentsideas"
    }}>{`How can I contribute and/or propose new components/ideas?`}</h3>
    <p>{`We have contributing guidelines for `}<a parentName="p" {...{
        "href": "/contributing/developers"
      }}>{`development`}</a>{` and `}<a parentName="p" {...{
        "href": "/contributing/designers"
      }}>{`design`}</a>{`. Thanks for the help!`}</p>
    <h3 {...{
      "id": "which-browsers-are-supported"
    }}>{`Which browsers are supported?`}</h3>
    <p>{`Carbon components are supported in the following browsers:`}</p>
    <ul>
      <li parentName="ul">{`IE11`}</li>
      <li parentName="ul">{`Microsoft Edge latest`}</li>
      <li parentName="ul">{`Firefox latest`}</li>
      <li parentName="ul">{`Chrome latest`}</li>
      <li parentName="ul">{`Safari latest`}</li>
    </ul>
    <h3 {...{
      "id": "what-languages-are-the-components-written-in"
    }}>{`What languages are the components written in?`}</h3>
    <p>{`There are four different implementations of the Carbon Design System. One is a vanilla JavaScript library; that’s written in ES6+, SCSS, and HTML and ships deliverables in vanilla JavaScript in ES5 as well as ES6, CSS, SCSS and HTML. Another is a React library that ships a React rewrite of the JavaScript, but uses the same CSS as the core library. There are also Angular and Vue libraries that use the same CSS.`}</p>
    <h3 {...{
      "id": "i-see-a-bug-how-do-i-report-it"
    }}>{`I see a bug. How do I report it?`}</h3>
    <p>{`First, make sure the problem is reproducible. Once confirmed, open an issue in the appropriate GitHub repo (see below). We will address the bug as soon as we can. If you have a fix for the bug, please feel free to submit a PR for it.`}</p>
    <h4 {...{
      "id": "design-issue-repos"
    }}>{`Design issue repos`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-design-kit/issues/new"
        }}>{`Design Kit`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-icons/issues/new"
        }}>{`Icons`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-website/issues/new/choose"
        }}>{`Website`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/issues/new/choose"
        }}>{`Components`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/issues/new/choose"
        }}>{`Elements`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts/issues/new"
        }}>{`Charts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/issue-tracking/issues/new"
        }}>{`Everything else`}</a></li>
    </ul>
    <h4 {...{
      "id": "code-repos"
    }}>{`Code repos`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/issues/new/choose"
        }}>{`carbon-components`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/issues/new/choose"
        }}>{`carbon-components-react`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-components-angular/issues/new"
        }}>{`carbon-components-angular`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-components-vue/issues/new"
        }}>{`carbon-components-vue`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts/issues/new"
        }}>{`carbon-charts`}</a></li>
    </ul>
    <h3 {...{
      "id": "what-can-i-expect-for-a-response-to-my-bug-report"
    }}>{`What can I expect for a response to my bug report?`}</h3>
    <p>{`If you have a pressing bug or change it is best to make PR for the issue yourself. Our team works in sprints and will try to address your bug as soon as possible; sometimes within two or three days, but usually by the following sprint. Issues that are out of scope will be closed until they become a higher priority.`}</p>
    <p>{`Typical responses to bug reports will include:`}</p>
    <ul>
      <li parentName="ul">{`Need more info, can’t reproduce the problem`}</li>
      <li parentName="ul">{`Won’t fix, this isn’t something we intend to support`}</li>
      <li parentName="ul">{`Confirmed, will add to our roadmap (Carbon team will fix)`}</li>
      <li parentName="ul">{`Confirmed, will accept PRs (need external member to fix)`}</li>
      <li parentName="ul">{`Need to include design to verify this behavior is supported`}</li>
    </ul>
    <h3 {...{
      "id": "what-should-i-do-if-i-find-a-component-that-isnt-accessible"
    }}>{`What should I do if I find a component that isn’t accessible?`}</h3>
    <p>{`First, refer to the `}<a parentName="p" {...{
        "href": "/guidelines/accessibility"
      }}>{`Carbon accessibility guidelines`}</a>{` to confirm that the component fails accessibility standards. If confirmed, `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/issues/new/choose"
      }}>{`create a GitHub issue`}</a>{` in the Components repo and describe the steps to reproduce the problem. If the core Carbon team confirms the problem, we will work to fix it as quickly as possible.`}</p>
    <h3 {...{
      "id": "i-havent-updated-to-the-latest-version-of-carbon-yet-and-i-still-need-the-old-documentation-where-can-i-find-it"
    }}>{`I haven’t updated to the latest version of Carbon yet, and I still need the old documentation. Where can I find it?`}</h3>
    <p>{`Every version of Carbon that is still supported is hosted at its own domain. You can find the old sites version here:
`}<strong parentName="p"><a parentName="strong" {...{
          "href": "http://v6.carbondesignsystem.com/"
        }}>{`V6`}</a></strong>{`, `}<strong parentName="p"><a parentName="strong" {...{
          "href": "http://v7.carbondesignsystem.com/"
        }}>{`V7`}</a></strong>{`, `}<strong parentName="p"><a parentName="strong" {...{
          "href": "http://v8.carbondesignsystem.com/"
        }}>{`V8`}</a></strong>{`, and `}<strong parentName="p"><a parentName="strong" {...{
          "href": "http://v9.carbondesignsystem.com/"
        }}>{`V9`}</a>{`.`}</strong></p>
    <h3 {...{
      "id": "im-an-internal-ibm-team-and-want-to-know-about-coo-status-is-there-an-approval-on-file"
    }}>{`I’m an internal IBM team and want to know about COO status. Is there an approval on file?`}</h3>
    <p>{`Carbon v10.x`}</p>
    <ul>
      <li parentName="ul">{`COO record ID: 95607540`}</li>
      <li parentName="ul">{`COO reference number: COO20190204`}</li>
      <li parentName="ul">{`Name of IBM material (with version number): IBM Design System `}{`[Version 10, Release n/a, Modification n/a]`}</li>
      <li parentName="ul">{`Last release date: March 31, 2019`}</li>
      <li parentName="ul">{`Name of Product/Program manager or author of material: Daniel Kuehn/Austin/IBM`}</li>
    </ul>
    <p>{`Carbon v9.x`}</p>
    <ul>
      <li parentName="ul">{`COO number of IBM material (if any): AUS720180239`}</li>
      <li parentName="ul">{`Name of IBM material (with version number): IBM Design System `}{`[Version 9, Release n/a, Modification n/a]`}</li>
      <li parentName="ul">{`Last release date: June 4, 2018`}</li>
      <li parentName="ul">{`Name of Product/Program manager or author of material: Daniel Kuehn/Austin/IBM`}</li>
    </ul>
    <h3 {...{
      "id": "where-do-i-find-charts-and-data-visualization"
    }}>{`Where do I find charts and data visualization?`}</h3>
    <p>{`Carbon charts are in development and classified as experimental. Check out the `}<a parentName="p" {...{
        "href": "https://carbon-design-system.github.io/carbon-charts/?experimental=true"
      }}>{`experimental charts repo`}</a>{` to explore the work so far.`}</p>
    <p>{`These charts will receive an updated color palette to match Carbon v10. Visual guidance and chart components are also in the works!`}</p>
    <h3 {...{
      "id": "how-do-i-migrate-an-existing-design-from-a-12-column-grid-to-the-16-column-grid"
    }}>{`How do I migrate an existing design from a 12 column grid to the 16 column grid?`}</h3>
    <p>{`There are many ways to move content from a 12 column grid onto a 16 column grid. If keeping the number of columns unchanged is not important to you, see below examples.`}</p>
    <Video vimeoId="356743483" mdxType="Video" />
    <Video vimeoId="356743492" mdxType="Video" />
    <Video vimeoId="356743508" mdxType="Video" />
    <p>{`If keeping the number of columns to 3 is essential, here are some other options.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "130.3030303030303%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaCAYAAAC3g3x9AAAACXBIWXMAAAsSAAALEgHS3X78AAADcUlEQVRIx41VaXfiOgzN//9lsxQ6LYUmhBACSchGnI21yx1JsQNl+s55H3SuLQvFlq4uVppXiLYKcbxDGBYIowJRXiMqW8Rlg1Cwlf29mbNQ7xPVwtokOSZzH44fIswUJaMP7DhRQ0GEO43lV+zt+tEhoR9t8eN5hkfbhZ/ukNR7xHQQqw7bqkPESBbfYG+tJP/nhsE2gx3E8KIUC7LlNoe/LWidYRlngn5SiN+jvad9QVZ+f0PHX+NhOsfjq4vR1MHzfImJ65PPId9c8GWxwh/Hw2jmYDxzxecEUX9T/XS2lBO6QYixvcATJfoz9/DiBZgu15KAkz/aHma0n+ikTw7FUfx8HfeJdrXUmS2h5JbqTsiaI/L6iKw6IKu1tScU3RkZWc4xgucBzbq48ZX7E6z2cEFadCjVAVV7QdXQgTpC7d9QvwHq/In68onK2Fkbrc2Z0r6O4q1U1RhR/bhOGd2Ek7hhIk+XpxIuaG9TzUw5poQeNWbmb2jf+7gkaUU1LJo9XOrupqhQ7C/0RUhTfhGVRlMbvyavlKCv329a/36xBfljoxk17aX3/aT4uFCw9u9ATdZ9QG7HT2H+bYpayMuYCB+Jb0MDauGrkFz7OE4dzpTwrk58w/a9N/5Io9eCH/pM+5vbGEK+nNW9faI83xf7Q6wiK089Gp86fV1XxkfWXj5gZfy0uBRxiCJjvUAMo1d9N3rdMJ5mndUdrDWN3uPrQjq3ZnHQNRpE4RY1gb87E2IrIvYqTvFA3eKpWA3i0P0Pcfj3hkIbTjhbRSIMzD93kwjOB9xqkaBzWrOfbRnnfbyO5bgwL1kcAuKRI8JwaywAYxIDPmNe8vw+3JzxIIy1oIxIXJiLfpTA8jYxnugHPAWDUTAzn/HZXcFehTQNG/EZM5PTxwYU5yMgsbbK7tiLA9lVGI4yhiIKrcbuirfrW5+IQ0PjluQNCrUXcVA1zTNxiqemkcnpkQlfG7yYqbrGsE+InZS1dHmixYFZz4cm6L/QrE1CNlGbnMjI4hASwfl5/QS8DxNS0rrff0Wlp8j42FqaMvlP4aKyekiB3ZV0lX0sW8+mEe61IdwAI3F97EoUX4i9WEf4SXJ0T5sxlcFebeT/5jtKvZIWDrShWJY0ka8ddVn+sNW90Ww2B5Et3kd35ymd9dPTyjTx/0t1vOAvugGTsNsBwg8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "3 col layouts on Duo grid",
        "title": "3 col layouts on Duo grid",
        "src": "/static/821024e9db1e2db572491653be6b4e05/fb070/3col-layouts.png",
        "srcSet": ["/static/821024e9db1e2db572491653be6b4e05/d6747/3col-layouts.png 288w", "/static/821024e9db1e2db572491653be6b4e05/09548/3col-layouts.png 576w", "/static/821024e9db1e2db572491653be6b4e05/fb070/3col-layouts.png 1152w", "/static/821024e9db1e2db572491653be6b4e05/fb104/3col-layouts.png 1728w", "/static/821024e9db1e2db572491653be6b4e05/e05c7/3col-layouts.png 2112w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      